var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2, _circle3, _circle4, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReserved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#A569BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 35,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#4A90E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 25,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#357ABD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 155,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#4A90E2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 185,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#357ABD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 95,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#4A90E2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 105,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#357ABD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 95,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#4A90E2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 105,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#357ABD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80,
    r: 10,
    fill: "#F7DC6F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 140,
    r: 10,
    fill: "#F7DC6F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 110,
    r: 10,
    fill: "#F7DC6F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 110,
    r: 10,
    fill: "#F7DC6F"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 72,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 72,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 132,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 132,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 106,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 106,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 106,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 106,
    width: 2,
    height: 10,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 50,
    width: 35,
    height: 18,
    rx: 4,
    fill: "#F39C12"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 177,
    y: 63,
    fontSize: 10,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "Arial",
    fontWeight: "bold"
  }, "RES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserved);
export default __webpack_public_path__ + "static/media/reserved.4dc3a37ffb05408be570255459b3647c.svg";
export { ForwardRef as ReactComponent };